import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import { i18n } from 'src/i18n';
import actions from 'src/modules/inventario/form/inventarioFormActions';
import selectors from 'src/modules/inventario/form/inventarioFormSelectors';
import { getHistory } from 'src/modules/store';
import InventarioForm from 'src/view/inventario/form/InventarioForm';
import ContentWrapper from 'src/view/layout/styles/ContentWrapper';
import Breadcrumb from 'src/view/shared/Breadcrumb';
import Spinner from 'src/view/shared/Spinner';
import PageTitle from 'src/view/shared/styles/PageTitle';

function InventarioFormPage(props) {
  const [dispatched, setDispatched] = useState(false);
  const dispatch = useDispatch();
  const match = useRouteMatch();

  const initLoading = useSelector(
    selectors.selectInitLoading,
  );
  const saveLoading = useSelector(
    selectors.selectSaveLoading,
  );
  const record = useSelector(selectors.selectRecord);

  const isEditing = Boolean(
    props.record?.id || match.params.id,
  );

  const title = isEditing
    ? i18n('entities.inventario.edit.title')
    : i18n('entities.inventario.new.title');

  useEffect(() => {
    dispatch(
      actions.doInit(props.record?.id || match.params.id),
    );
    setDispatched(true);
  }, [dispatch, match.params.id]);

  const doSubmit = (id, data) => {
    if (isEditing) {
      dispatch(actions.doUpdate(id, data));
    } else {
      dispatch(actions.doCreate(data));
    }
  };

  return (
    <>
      {!props.drawer ||
        (!props.disabled && (
          <Breadcrumb
            items={[
              [i18n('dashboard.menu'), '/'],
              [
                i18n('entities.inventario.menu'),
                '/inventario',
              ],
              [title],
            ]}
          />
        ))}

      <ContentWrapper>
        {!props.disabled && <PageTitle>{title}</PageTitle>}

        {initLoading && <Spinner />}

        {dispatched && !initLoading && (
          <InventarioForm
            disabled={props.disabled}
            drawer={props.drawer}
            saveLoading={saveLoading}
            initLoading={initLoading}
            record={record}
            isEditing={isEditing}
            onSubmit={doSubmit}
            onCancel={() =>
              getHistory().push('/inventario')
            }
          />
        )}
      </ContentWrapper>
    </>
  );
}

export default InventarioFormPage;
